import { clientAuthAxios } from './clientAuth';
import { ChangePasswordResponse, RequestPasswordResetResponse } from './types';

export const requestPasswordReset = (email: string) =>
  clientAuthAxios.post<RequestPasswordResetResponse>('password', {
    user: { email },
  });

export const changePasswordWithToken = ({
  token,
  password,
  passwordConfirmation,
}: {
  token: string;
  password: string;
  passwordConfirmation: string;
}) =>
  clientAuthAxios.put<ChangePasswordResponse>('password', {
    user: {
      reset_password_token: token,
      password,
      password_confirmation: passwordConfirmation,
    },
    scope: 'default',
  });

export const changePasswordWithClient = ({
  password,
  passwordConfirmation,
}: {
  password: string;
  passwordConfirmation: string;
}) =>
  clientAuthAxios.put<ChangePasswordResponse>('new_password', {
    password,
    password_confirmation: passwordConfirmation,
    scope: 'default',
  });
